<template>
    <div class="prop-selected-wrap">
        <div class="select-label" :class="{ 'select-ative': isShowOption }" @click.stop="clickHandler">
            {{ title }}
        </div>
        <div class="prop-select-list" v-show="currentLabel.length > 0 && !isShowOption">
            <div class="prop-select-item" v-for="(item, idx) in currentLabel" :key="idx">
                {{ item.label }}
                <Icon
                    class="prop-right-icon"
                    :width="18"
                    :height="18"
                    :bgPosition="deletePosition"
                    @iconClick="deleteHandle(item)"
                    :hoverBgPosition="deleteHoverPosition"
                />
            </div>
        </div>
        <div class="tag-select-options" v-show="isShowOption">
            <MultiPopupMenu :current="computedInitData" :options="options" :check-status="checkStatus" @menuClick="selectClick" />
        </div>
    </div>
</template>

<script>
import Icon from "@/views/zhiji/bComponents/icons/Icon";
import MultiPopupMenu from "./MultiPopupMenu";

export default {
    name: "PropMutliSelect",
    props: ["initData", "options", "disable", "title", "cycleTimeCheckStatus"],
    components: {
        Icon,
        MultiPopupMenu
    },
    data() {
        return {
            isShowOption: false,
            currentLabel: this.initCurrent(),
            deletePosition: "-4px -1px",
            deleteHoverPosition: "-252px -20px",
            hoverPosition: "-386px -62px",
            optionsInit: this.initData,
            checkStatus: this.cycleTimeCheckStatus,
        };
    },
    computed: {
        computedInitData() {
            return this.optionsInit;
        }
    },
    watch: {
        initData() {
            this.optionsInit = this.initData;
            this.currentLabel = this.initCurrent();
        },
        options() {
            this.currentLabel = this.initCurrent();
        },
        cycleTimeCheckStatus(newValue) {
            this.checkStatus = newValue;
        }
    },
    methods: {
        clickHandler() {
            !this.disable && (this.isShowOption = !this.isShowOption);
        },
        selectClick(data) {
            this.currentLabel = this.initCurrent();
            this.$emit("clickSelectIds", data.ids);
            this.$emit("clickSelect", data.item);
        },
        deleteHandle(data) {
            let propsIdStr = this.optionsInit.toString();
            if (propsIdStr.indexOf(data.value > 0)) {
                propsIdStr = propsIdStr.replace(data.value, "");
            }
            let newVal = propsIdStr.split(",").filter(Boolean);
            this.optionsInit = newVal;
            this.currentLabel = this.initCurrent();

            this.$emit("deleteSelected", newVal);
        },
        initCurrent() {
            let currentLabel = [];
            this.optionsInit = this.initData;
            this.optionsInit &&
                this.optionsInit.forEach(item => {
                    this.options.forEach(option => {
                        if (item == option.value) {
                            currentLabel.push(option);
                        }
                    });
                });

            return currentLabel;
        },
        windowClick(event) {
            if (this.isShowOption && this.zhiji.isClickOuter(event, "prop-selected-wrap")) {
                this.isShowOption = false;
            }
        }
    },
    mounted() {
        window.document.addEventListener("click", this.windowClick);
    },
    destroyed() {
        window.document.removeEventListener("click", this.windowClick);
    }
};
</script>

<style scoped lang="less">
.prop-selected-wrap {
    position: relative;

    .select-label {
        position: relative;
        font-size: 12px;
        box-sizing: border-box;
        padding: 8px 16px 9px;
        border-width: 0 0 1px 0;
        border-style: solid;
        border-color: #d8e4f0;
        background: #fff;
        cursor: pointer;

        &:after {
            position: absolute;
            top: 13px;
            right: 16px;
            content: "";
            width: 6px;
            height: 10px;
            display: inline-block;
            background: url("@{zhijiStaticImagePath}class-spr.png");
            background-position: -127px -20px;
            transform: rotate(90deg);
        }

        .tag-placeholder {
            display: inline-block;
            height: 35px;
            line-height: 35px;
            color: #9e9e9e;
            margin-left: 6px;
        }
        .tag-list-panle {
            list-style: none;
            display: flex;
            flex-wrap: wrap;

            .tag-list-item {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 4px 6px;
                background: #e4f1f9;
                border-radius: 3px;
                margin: 2px;

                .tag-item-delete {
                    margin-left: 7px;
                }
            }
        }
    }
    .select-ative {
        &:after {
            transform: rotate(270deg);
            transition: transform 0.2s ease-in-out;
        }
    }

    .tag-select-options {
        position: absolute;
        width: 100%;
        background-color: #fff;
        border-radius: 5px;
        margin: 5px 0;
        box-sizing: border-box;
        z-index: 100;

        .select-options-panel {
            width: 100%;
            position: relative;
        }
    }
}

.prop-select-list {
    display: flex;
    flex-wrap: wrap;
    padding: 16px 16px 8px 16px;
    border-bottom: 1px solid #d8e4f0;

    .prop-select-item {
        display: flex;
        align-items: center;
        font-size: 12px;
        position: relative;
        padding: 6px 16px 6px 8px;
        box-sizing: border-box;
        margin-bottom: 8px;
        width: calc(50% - 4px);
        border-radius: 4px;
        background: #e3ecf3;
        &:hover {
            .prop-right-icon {
                display: block;
            }
        }
        .prop-right-icon {
            display: none;
            position: absolute;
            right: 6px;
            top: 50%;
            margin-top: -9px;
        }
    }

    .prop-select-item:nth-child(2n + 1) {
        margin-right: 8px;
    }
}
</style>
